// extracted by mini-css-extract-plugin
export default {"form":"CreateCourse_form__f3vJj","formInputBlock":"CreateCourse_formInputBlock__jTC5o","formInput":"CreateCourse_formInput__B2CKk","copyLinkBtn":"CreateCourse_copyLinkBtn__lZgEw"};